import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import ContractorsSchema from 'schemas/ChecklistSettings.schema.json';
import { useAppContext } from 'hooks/useAppContext';
import {useFormContext} from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';
import ODataUtil from 'utils/ODataUtil';
import { updateDocument } from 'utils/DocumentsUtils'

const ChecklistDetailsDisplay = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties, }) => {
    defaultValues = ODataUtil.unCoupleExpandsFromDefaults(defaultValues);
    console.log(defaultValues)

    const { selectedProject, selectedProjectData } = useAppContext();

    const formContext = useFormContext();
 
    useEffect(() => {
        !formContext.schema && formContext.updateSchema(ContractorsSchema);
    })

    const onSubmit = async (values) => {
        console.log(CRUDType)
        let result;
         if (CRUDType === "UPDATE") {
            values.ProjDocId = defaultValues.ProjDocId;
            result = await updateDocument(values, defaultValues)
            setTimeout(callback, 1000);
        };

        return result;
    };
    /* 
    on rare occasions, this component may be reached before the full AppContext is done initializing.
    so this form only renders when there is data in selectedProjectData 
    */
    return selectedProjectData && formContext.ready ? 
    withExtension(DynamicForm, { schema: ContractorsSchema, orientation, onSubmit, defaultValues, disabledProperties, hiddenProperties, definitions: formContext.definitions }) :
    <SkeletonForm />

}



ChecklistDetailsDisplay.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

ChecklistDetailsDisplay.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}




export default ChecklistDetailsDisplay
